import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const InseminatorIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M17.76,23.56a1.25,1.25,0,0,1-1.25-1.24V19.84H14a1.25,1.25,0,0,1,0-2.49h2.48V14.87a1.25,1.25,0,0,1,2.49,0v2.48h2.48a1.25,1.25,0,0,1,0,2.49H19v2.48A1.25,1.25,0,0,1,17.76,23.56Z" />
      <path d="M11,12.44A5.38,5.38,0,0,1,5.61,7a5.4,5.4,0,0,1,10.8,0A5.38,5.38,0,0,1,11,12.44Zm0-8.8A3.44,3.44,0,0,0,7.61,7,3.4,3.4,0,1,0,11,3.64Z" />
      <path d="M10.21,20.14H4a5.19,5.19,0,0,1,5.2-4.5h1.7a11.84,11.84,0,0,1,1.4-2.2H9.11a7.7,7.7,0,0,0-7.7,7.7,1.32,1.32,0,0,0,1.3,1.3h8.1A11.2,11.2,0,0,1,10.21,20.14Z" />
    </SvgIcon>
  )
}
export default InseminatorIcon
